<nav class="status d-flex align-items-stretch">
  <a
    (click)="updateViewType(sitemateRecordStatuses.Open)"
    class="btn cc-btn-subtle-white"
    [class.active]="statusViewType === sitemateRecordStatuses.Open"
    ><span>Active</span></a
  >
  <a
    (click)="updateViewType(sitemateRecordStatuses.Archived)"
    class="btn cc-btn-subtle-white update-view-archived"
    [class.active]="statusViewType === sitemateRecordStatuses.Archived"
    [class.disabled]="archivedLinks.length === 0"
    ><i class="cc-icon cc-icon-archive mr-2"></i><span>Archived</span></a
  >
</nav>

<div class="table-styling">
  <table class="animate-fade-in table">
    <thead>
      <tr>
        <th class="field-name" i18n>Link Name</th>
        <th class="field-url" i18n>URL</th>
        <th class="field-templates-count" i18n>Templates</th>
        <th class="field-actions"></th>
      </tr>
    </thead>

    <tbody class="status-{{ statusViewType }}-type">
      <tr *ngFor="let link of links">
        <td class="text-truncate align-middle field-name">{{ link.name }}</td>
        <td class="align-middle field-url" *ngIf="statusViewType === sitemateRecordStatuses.Open">
          <a [cdkCopyToClipboard]="link.url" (click)="onLinkCopied()" class="hover:sm-no-underline"
            >{{ link.urlLabel }}<i class="cc-icon cc-icon-link-chain"></i
          ></a>
        </td>
        <td class="align-middle field-url" *ngIf="statusViewType === sitemateRecordStatuses.Archived">
          <span>{{ link.urlLabel }}</span>
        </td>
        <td class="text-truncate align-middle field-templates-count">
          <a (click)="onTemplateLinkTemplatesAccessed(link)" class="hover:sm-no-underline"
            >{{ link.templateMetadata?.length }} Template{{
              link.templateMetadata?.length !== 1 ? 's' : ''
            }}</a
          >
        </td>
        <td class="field-actions align-middle text-right">
          <button
            class="btn cc-btn-subtle-gray mr-1 field-action-pdf"
            *ngIf="statusViewType === sitemateRecordStatuses.Open"
            (click)="onGetQrCodePoster(link.url)"
            [ngbTooltip]="templateLinkToolTips.downloadPoster"
            placement="bottom"
            tooltipClass="template-links-tooltip"
            container="body"
          >
            <i class="cc-icon cc-icon-download-pdf"></i>
          </button>
          <button
            (click)="onEditLink(link)"
            class="btn cc-btn-subtle-gray mr-1 field-action-edit"
            *ngIf="statusViewType === sitemateRecordStatuses.Open && isTeamControllerOrAbove"
            [ngbTooltip]="templateLinkToolTips.edit"
            placement="bottom"
            tooltipClass="template-links-tooltip"
            container="body"
          >
            <i class="cc-icon cc-icon-pencil"></i>
          </button>
          <button
            class="btn cc-btn-subtle-gray mr-1 field-action-archive"
            (click)="onArchiveLink(link)"
            *ngIf="statusViewType === sitemateRecordStatuses.Open && isTeamControllerOrAbove"
            [ngbTooltip]="templateLinkToolTips.archive"
            placement="bottom"
            tooltipClass="template-links-tooltip"
            container="body"
          >
            <i class="cc-icon cc-icon-archive"></i>
          </button>
          <button
            class="btn cc-btn-subtle-gray mr-2 field-action-undo"
            (click)="onUnarchiveLink(link)"
            *ngIf="statusViewType === sitemateRecordStatuses.Archived && isTeamControllerOrAbove"
            [ngbTooltip]="templateLinkToolTips.restore"
            placement="bottom"
            tooltipClass="template-links-tooltip"
            container="body"
          >
            <i class="cc-icon cc-icon-undo"></i>
          </button>
        </td>
      </tr>

      <tr *ngIf="links.length === 0">
        <td class="no-links">
          <span *ngIf="statusViewType === sitemateRecordStatuses.Open" i18n>There are no active links</span>
          <span *ngIf="statusViewType === sitemateRecordStatuses.Archived" i18n
            >There are no archived links</span
          >
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #templateLinksTemplatesModal let-close="close">
  <cc-template-links-templates-list-modal
    [taskDefinition]="taskDefinition"
    (close)="close()"
  ></cc-template-links-templates-list-modal>
</ng-template>
